import { v4 as uuidv4 } from 'uuid';

// Sends a JSON-RPC request directly to ClaimCenter using only headers
// that are in the CC CORS allowlist. The shared BaseTransportService injects
// Accept-Language, x-gwre-session, and x-captcha which CC does not allow.
export default class ClaimsDirectService {
    static send(url, method, params, additionalHeaders = {}) {
        if (!url) {
            return Promise.reject(new Error('Claims URL is not configured'));
        }

        const traceId = uuidv4();
        const id = `${traceId}_claims`;

        const headers = {
            'Content-Type': 'application/json; charset=utf-8',
            'Accept': 'application/json',
            'X-B3-TraceId': id,
            'X-B3-SpanId': id,
            'X-B3-Sampled': '0',
            ...additionalHeaders
        };

        // CC CORS preflight blocks x-captcha; never forward it on direct CC calls.
        delete headers['x-captcha'];

        const body = JSON.stringify({ id, jsonrpc: '2.0', method, params });

        return fetch(url, { method: 'POST', headers, body })
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401) {
                        return Promise.reject({ status: 401, isUnauthenticated: true });
                    }
                    return Promise.reject(new Error(`${response.status} (${response.statusText})`));
                }
                return response.json();
            })
            .then((json) => json.result);
    }
}
